import MicroModal from 'micromodal';

class Lightboxes {
	lightboxes: NodeListOf<Element>;
	constructor() {
		this.lightboxes = document.querySelectorAll('[data-micromodal]');
	}
	init() {
		MicroModal.init({ awaitOpenAnimation: true, awaitCloseAnimation: true });

		if (this.lightboxes) {
			this.lightboxes.forEach((lightbox) => {
				const trigger = lightbox.parentElement?.querySelector('[data-lightbox-trigger]');
				if (trigger && lightbox instanceof HTMLElement) {
					trigger.addEventListener('click', (e) => {
						e.preventDefault();
						if (lightbox.dataset.lightboxId) {
							MicroModal.show(lightbox.dataset.lightboxId, {
								awaitOpenAnimation: true,
								awaitCloseAnimation: true,
							});
						}
					});
				}
			});
		}
	}
}

export default new Lightboxes();
